<template>
  <div class="bb-icon-cell">
    <div class="bb-icon-cell__text">{{value}}</div>
    <i class="icon-info bb-icon-cell__icon"
       ref="iconTransfer"
       @mouseenter="setPositionPopup($event, row._id)"
       @mouseleave="showTransfer = false"
    />
    <transition name="fade" mode="out-in">
      <div v-if="showTransfer === row._id"
           :style="openTransfer"
           class="bb-icon-cell-popup"
      >
        <div class="bb-icon-cell-popup__container">
          <span class="bb-icon-cell-popup_bold">70%</span>
          <span>(7,000.00)</span>
          <span class="bb-icon-cell-popup_name">Alex Alexandrov</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
export default {
  name: 'IconCell',
  props: ['row', 'column', 'index'],
  computed: {
    value: {
      get: function () {
        return get(this.row, this.column.prop, '')
      }
    }
  },
  data () {
    return {
      showTransfer: false,
      openTransfer: {
        left: 0,
        top: 0
      }
    }
  },
  methods: {
    setPositionPopup (e, rowId) {
      this.showTransfer = rowId
      const popups = get(this.$refs, 'iconTransfer', '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.openTransfer = {
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-icon-cell {
  @include global-font;
  position: relative;
  display: flex;
  align-items: center;

  &__icon {
    color: $color-silver-chalice;
    padding-left: 4px;
    font-size: 13px;
    cursor: pointer;
  }

  &-popup {
    position: fixed;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    color: black;

    &__container {
      padding: 12px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }

    &_bold {
      font-weight: bold;
      padding-right: 6px;
    }

    &_name {
      padding-left: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/IconCell/IconCell.vue